import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarkdownFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "MarkdownFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.44 10.13a1 1 0 0 0-.19-.29l-7.51-7.42c-.09-.1-.19-.2-.29-.28a1 1 0 0 0-.48-.14h-9.64c-2.3 0-4.18 1.85-4.21 4.16v7.95h-2.8c-1.03 0-1.87.84-1.87 1.87v6.54c0 1.03.84 1.87 1.87 1.87h2.8v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.74q0-.315-.12-.6ZM7.19 18.7v4.09H5.12v-7.1h2.07l2.08 2.59 2.07-2.59h2.07v7.1h-2.07V18.7l-2.07 2.59zm19.57 7.56c0 .77-.76.97-1.4.97H11.34c-.64 0-1.4-.17-1.4-.97v-1.87h11.22c1.03 0 1.87-.84 1.87-1.87v-6.54c0-1.03-.84-1.87-1.87-1.87H9.94V6.16c0-.77.63-1.4 1.4-1.4h7.95V9.9c0 1.29 1.05 2.34 2.34 2.34h5.14v14.02Zm-5.55-6.93-3.12 3.47-3.11-3.43h2.07V15.7h2.07v3.63h2.07Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11 20.35h2.07l2.6 3.72 2.6-3.72h2.07v8.94h-2.29v-5.1l-2.26 2.86h-.26l-2.26-2.86v5.1h-2.28v-8.94ZM26.41 29.29c-.63 0-1.14-.51-1.14-1.14v-6.84a1.14 1.14 0 1 1 2.28 0v6.84c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.41 29.29c-.29 0-.58-.11-.81-.33l-2.84-2.84c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l2.04 2.04 2.04-2.04c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-2.84 2.84c-.22.22-.52.33-.81.33ZM6.43 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h1.14a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 17.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};
MarkdownFileIcon.displayName = 'MarkdownFileIcon';